

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Style/Question.css';
import Loading from "../../Common/Loading";
import $ from "jquery";
import "jquery-ui/ui/widgets/dialog";
import "jquery-ui/themes/base/all.css";

import OQns from './OQns';
import WQns from './WQns';
import FQns from './FQns';
import DQns from './DQns';
import BQns from './BQns';
import RadioQns from './RadioQns';
import NQns from './NQns';
import IQns from './IQns';
import CQns from './CQns';
import MQns from './MQns';
import LQns from './LQns';
import ImageQns from './ImageQns';
import { getQuestionTypeFromHtml } from './utils/questionTypeUtilsQuestion';
import { LogIn } from 'lucide-react';
import WhiteboardLink from '../../Common/WhiteboardLink';


const buildLegacyHiddenQuestionData = (questions: any[] | undefined): string =>
  (questions || [])
    .map((question) => [
      question.LastQnInd ?? '',
      question.QnNo ?? question.QuestionNo ?? '',
      question.SubNo ?? 0,
      question.VarValues ?? '',
      question.QnType ?? question.QuestionType ?? '',
      question.PrincipleNos ?? question.PrcNos ?? '',
      question.NoOfPrinciples ?? question.NoOfPrc ?? 0,
      question.NoOfClues ?? 0,
      question.NoOfSolutions ?? question.NoOfSol ?? 0,
    ].join('-|-'))
    .join('-^-');

const Question: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lessonMeta, setLessonMeta] = useState<any>(null);
  const [allQuestionsHtml, setAllQuestionsHtml] = useState<Record<string, string>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [correctAudio, setCorrectAudio] = useState<string[]>([]);
  const [incorrectAudio, setIncorrectAudio] = useState<string[]>([]);
  const [sessionId, setSessionId] = useState<number | null>(null);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isViewLesson = params.get("ViewLesson") === "Y";
  const searchCalledFromParam =
    params.get("calledFrom") || params.get("CalledFrom") || "";
  const isSearchActivitiesFlow = searchCalledFromParam
    .toLowerCase()
    .includes("/student/msr/searchactivities");
  // const closeOnBackOrOk = params.get("CloseOnBackOrOk") === "Y";

  // VIEW LESSON ONLY: preview mode is deliberately ignored for the student flow.
  const previewMode = isViewLesson
    ? (params.get("PreviewMode") || "").toUpperCase()
    : null;
  const folderParam = params.get('folder');
  const lessonNameParam = params.get('name') || 'Lesson';
  const subjectParam = sessionStorage.getItem('Subject');

  const schoolCode = sessionStorage.getItem("SchoolCode");
  const familyCode = sessionStorage.getItem("FamilyCode");
  const login = sessionStorage.getItem("Login");
  const whiteboardSchoolCode = params.get("SchoolCode") || params.get("schoolCode") || schoolCode;
  const whiteboardFamilyCode = params.get("FamilyCode") || params.get("familyCode") || familyCode;
  const whiteboardLogin = params.get("Login") || params.get("login") || login;

  // useEffect(() => {
  //   // if (!closeOnBackOrOk) return;

  //   const closeWindowOnBackOrOk = (event: MouseEvent) => {
  //     const target = event.target;
  //     if (!(target instanceof Element) || !target.closest('img[alt="Back"], img[alt="OK"], input[alt="OK"]')) {
  //       return;
  //     }

  //     event.preventDefault();
  //     event.stopImmediatePropagation();
  //     window.close();
  //   };

  //   document.addEventListener('click', closeWindowOnBackOrOk, true);
  //   return () => document.removeEventListener('click', closeWindowOnBackOrOk, true);
  // }, [closeOnBackOrOk]);
  const hwidRaw = params.get("hwid");
  let hwid: number | null = null;
  if (hwidRaw === "0") hwid = 0;
  else if (hwidRaw && hwidRaw !== "null") hwid = parseInt(hwidRaw);

  const url = process.env.REACT_APP_DOCUMENT_LINK;
  const assetsBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;
  const showAlert = useCallback((message: string) => {
    const $dialog = $("#dialog-confirm") as any;
    $("#dialog-confirm p").text(message);

    $dialog.dialog({
      autoOpen: true,
      title: "Alert",
      resizable: false,
      height: "auto",
      draggable: false,
      width: 250,
      modal: true,
      closeOnEscape: false,
      buttons: {
        "OK": function () {
          $(this).dialog("close");
          $(this).dialog("destroy");
        },
      },
      create: function () {
        $(this).parent().find(".ui-dialog-titlebar-close").remove();
      },
      open: function () {
        $(this).parent().find(".ui-dialog-titlebar-close").remove();
        $(".ui-widget-header").css("background", "#7a96df");
        $(".ui-dialog-title").css({ "width": "100%", "text-align": "center" });

        const $buttonPane = $(".ui-dialog-buttonpane");
        $buttonPane.css("padding", "0");

        const $buttonSet = $buttonPane.find(".ui-dialog-buttonset");
        $buttonSet.css({
          "display": "flex",
          "justify-content": "center",
          "width": "100%"
        });

        $buttonPane.find("button").css({
          "margin": "0.5em 1em",
          "cursor": "pointer",
          "font-size": "12pt"
        });

        $dialog.dialog("option", "position", { my: "center", at: "center", of: window });
        $(this).find("p").css({
          "font-size": "12pt",
          "margin": "10px 0",
          "text-align": "center"
        });
      },
    });
  }, []);

  const resetCurrentLessonSession = useCallback(async (sessionId: number, dicCode: string, lsnTestCode: string) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) throw new Error("Authentication token not found.");

    const resetRes = await fetch(`${url}reset_lesson_session/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        sessionId,
        SchoolCode: schoolCode,
        FamilyCode: familyCode,
        Login: login,
        DICCode: dicCode,
        LsnTestCode: lsnTestCode,
      }),
    });

    if (!resetRes.ok) {
      const errorBody = await resetRes.json().catch(() => ({}));
      throw new Error(errorBody.message || "Failed to reset the lesson session.");
    }

    return resetRes.json();
  }, [url, schoolCode, familyCode, login]);

  const showResumePrompt = useCallback((): Promise<'resume' | 'startover'> => {
    return new Promise((resolve) => {
      const $dialog = $("#dialog-confirm") as any;
      $("#dialog-confirm p").text("You have already started these questions. Do you want to...");

      $dialog.dialog({
        autoOpen: true,
        title: "Questions",
        resizable: false,
        height: "auto",
        draggable: false,
        width: 400,
        modal: true,
        closeOnEscape: false,
        buttons: {
          "Keep Going": function () {
            $(this).dialog("close");
            $(this).dialog("destroy");
            resolve('resume');
          },
          "Start Again": function () {
            $(this).dialog("close");
            $(this).dialog("destroy");
            resolve('startover');
          }
        },
        create: function () {
          $(this).parent().find(".ui-dialog-titlebar-close").remove();
        },
        open: function () {
          $(this).parent().find(".ui-dialog-titlebar-close").remove();
          $(".ui-widget-header").css("background", "#7a96df");
          $(".ui-dialog-title").css({ "width": "100%", "text-align": "center" });

          const $buttonPane = $(".ui-dialog-buttonpane");
          $buttonPane.css("padding", "0");

          const $buttonSet = $buttonPane.find(".ui-dialog-buttonset");
          $buttonSet.css({
            "display": "flex",
            "justify-content": "center",
            "width": "100%"
          });

          $buttonPane.find("button").css({
            "margin": "0.5em 0.2em",
            "cursor": "pointer",
            "font-size": "12pt"
          });

          $dialog.dialog("option", "position", { my: "center", at: "center", of: window });
          $(this).find("p").css({
            "position": "relative",
            "border": "0",
            "margin-top": "1em",
            "margin-bottom": "1em",
            "font-size": "12pt"
          });
        }
      });
    });
  }, []);

  const updateSessionPoints = (pointsEarned: number) => {
    if (pointsEarned > 0) {
      try {
        const currentPoints = parseInt(sessionStorage.getItem('CurrentPoints') || '0');
        const newTotalPoints = currentPoints + pointsEarned;
        sessionStorage.setItem('CurrentPoints', newTotalPoints.toString());
        window.dispatchEvent(new Event('pointsUpdated'));
        // console.log(`Updated CurrentPoints in session: ${newTotalPoints}`);
      } catch (e) {
        // console.error("Failed to update session points:", e);
      }
    }
  };

  useEffect(() => {
    const fetchLessonData = async () => {
      let currentSessionId: number | null = null;
      let pageToLoad: number = 1;

      let lastCompletedPage: number = 0;
      let isResuming = false;

      const urlParams = new URLSearchParams(window.location.search);
      const sessionIdParam = urlParams.get("sessionId");
      const currentPageParam = urlParams.get("currentPage");

      if (sessionIdParam && currentPageParam) {
        // console.log("Returning from Tutorial, skipping session check.");
        try {
          currentSessionId = parseInt(sessionIdParam);
          pageToLoad = parseInt(currentPageParam);

          setSessionId(currentSessionId);
          setCurrentPage(pageToLoad);

          setLoading(true);
          const accessToken = localStorage.getItem("access_token");
          if (!accessToken) throw new Error("Authentication token not found.");

          const metaRes = await fetch(`${url}LessonMeta/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({
              folder: folderParam,
              sessionId: currentSessionId,
              SchoolCode: schoolCode, FamilyCode: familyCode, LogIn: login,
              isViewLesson: isViewLesson,                                        // NEW
              QnNo: isViewLesson ? (params.get("QnNo") || undefined) : undefined, // NEW
            }),
          });
          if (!metaRes.ok) throw new Error("Network response was not ok for lesson metadata.");
          const meta = await metaRes.json();
          if (!meta || !meta.qns) throw new Error("Invalid metadata received from API.");

          setLessonMeta(meta);
          setTotalPages(meta.qns.length);

          const questionsRes = await fetch(`${url}Question/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({
              folder: folderParam,
              qns: meta.qns,
              calledFrom: 'Question',
              sessionId: currentSessionId,
              runid: currentSessionId,
              SchoolCode: schoolCode,
              FamilyCode: familyCode,
              Login: login,
            }),
          });
          if (!questionsRes.ok) throw new Error("Failed to fetch question HTML.");
          const questionsData = await questionsRes.json();
          setAllQuestionsHtml(questionsData.Questions);

          try {
            const res = await fetch(`${url}AudioFiles/`);
            if (!res.ok) throw new Error("Failed to fetch audio files.");
            const data = await res.json();
            setCorrectAudio(data.correct || []);
            setIncorrectAudio(data.incorrect || []);
          } catch (e) {
            // console.error("Could not load audio files:", e);
          }

        } catch (e: any) {
          // console.error(e);
          setError(`Failed to reload lesson data: ${e.message}`);
        } finally {
          setLoading(false);
        }
        return;
      }

      try {
        setLoading(true);

        try {
          const res = await fetch(`${url}AudioFiles/`);
          if (!res.ok) throw new Error("Failed to fetch audio files.");
          const data = await res.json();
          setCorrectAudio(data.correct || []);
          setIncorrectAudio(data.incorrect || []);
        } catch (e) {
          // console.error("Could not load audio files:", e);
        }

        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) throw new Error("Authentication token not found.");

        const dicCode = isViewLesson
          ? (params.get("diccode") || folderParam || "")
          : (
            (isSearchActivitiesFlow ? params.get("diccode") : null) ||
            sessionStorage.getItem("SelectedDICFile") ||
            params.get("diccode") ||
            folderParam ||
            ""
          );

        const lessonId = params.get("id") || "";
        const lsnTestCode = isSearchActivitiesFlow
          ? params.get("LsnTestCode") ||
            sessionStorage.getItem("LsnTestCode") ||
            lessonId.replace(/_E$/i, "") ||
            ""
          : sessionStorage.getItem("LsnTestCode") ||
            params.get("LsnTestCode") ||
            lessonId.replace(/_E$/i, "") ||
            "";

        if (!folderParam || !dicCode || !lsnTestCode) {
          throw new Error("Missing required lesson identifiers.");
        }

        // The final answer is persisted before Done is shown. If the learner
        // refreshes at that point, resume at the result for this exact lesson.
        const completionKey = `completedLesson:${dicCode}:${lsnTestCode}`;
        const completedSessionId =
          localStorage.getItem(completionKey) ||
          sessionStorage.getItem(completionKey);
        if (!isViewLesson && completedSessionId) {
          const calledFrom = params.get("calledFrom") || "";
          navigate(
            `/STUDENT/Tutorials/Result?DicCode=${encodeURIComponent(dicCode)}&LsnTestCode=${encodeURIComponent(lsnTestCode)}&SessionID=${encodeURIComponent(completedSessionId)}&source=lesson&complete=1` +
              (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : ""),
            { replace: true }
          );
          return;
        }

        let choice: 'resume' | 'startover' | 'new' = 'new';

        let inProgressSessionId: number | null = null;

        if (!isViewLesson) {

          const checkRes = await fetch(`${url}check_lesson_status/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({
              SchoolCode: schoolCode,
              FamilyCode: familyCode,
              Login: login,
              DICCode: dicCode,
              LsnTestCode: lsnTestCode,
            }),
          });

          if (!checkRes.ok)
            throw new Error("Failed to check lesson status.");

          const checkData = await checkRes.json();
          inProgressSessionId = typeof checkData?.sessionId === "number" ? checkData.sessionId : null;

          if (checkData.finalAnswerSaved && inProgressSessionId !== null) {
            navigate(
              `/STUDENT/Tutorials/Result?DicCode=${encodeURIComponent(dicCode)}&LsnTestCode=${encodeURIComponent(lsnTestCode)}&SessionID=${encodeURIComponent(String(inProgressSessionId))}&source=lesson&complete=1`,
              { replace: true }
            );
            return;
          }

          if (checkData.status === "in-progress") {

            setLoading(false);

            choice = await showResumePrompt();

            setLoading(true);

            if (choice === "resume") {

              currentSessionId = inProgressSessionId;
              lastCompletedPage = checkData.currentPage || 0;
              isResuming = true;

            }
          }

        }


        if (!isViewLesson && choice === "startover" && inProgressSessionId !== null) {
          currentSessionId = inProgressSessionId;
          await resetCurrentLessonSession(currentSessionId, dicCode, lsnTestCode);
          pageToLoad = 1;
        } else if (!isViewLesson && choice === "new") {
          // console.log("Initializing new lesson session...");
          const urlParams = new URLSearchParams(window.location.search);
          const calledFromParam =
            urlParams.get("CalledFrom") ||
            urlParams.get("calledFrom") ||
            "";

          const hwidRaw = urlParams.get("hwid");
          let hwidToSend = null;

          if (hwidRaw === "0") hwidToSend = 0;
          else if (hwidRaw && hwidRaw !== "null") hwidToSend = parseInt(hwidRaw);

          const initRes = await fetch(`${url}initialize_lesson/`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${accessToken}` },
            body: JSON.stringify({
              DICCode: dicCode,
              DICFileVersion: isSearchActivitiesFlow
                ? urlParams.get("dicFileVersion") ||
                  urlParams.get("DICFileVersion") ||
                  sessionStorage.getItem("DICFileVersion") ||
                  ""
                : sessionStorage.getItem("DICFileVersion") || "",
              UnitCode:
                (isSearchActivitiesFlow
                  ? urlParams.get("unitCode") || urlParams.get("UnitCode")
                  : null) ||
                sessionStorage.getItem("UnitCode") || "",
              ChapterCode:
                (isSearchActivitiesFlow
                  ? urlParams.get("chapterCode") || urlParams.get("ChapterCode")
                  : null) ||
                sessionStorage.getItem("ChapterCode") || "",
              LsnTestCode: lsnTestCode,
              calledFrom: calledFromParam,
              hwid: hwidToSend,
              SchoolCode: schoolCode, FamilyCode: familyCode, Login: login
            }),
          });
          if (!initRes.ok) {
            const errorBody = await initRes.text();

            console.error(
              "initialize_lesson FAILED:",
              initRes.status,
              errorBody
            );

            throw new Error(
              `Failed to initialize new lesson session. HTTP ${initRes.status}: ${errorBody}`
            );
          }
          const initData = await initRes.json();

          currentSessionId = initData.sessionId;
          pageToLoad = 1;

          if (currentSessionId === null || currentSessionId === undefined) {
            throw new Error("Invalid session ID received.");
          }
        }

        setSessionId(currentSessionId);

        const metaRes = await fetch(`${url}LessonMeta/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            folder: folderParam,
            sessionId: currentSessionId,
            SchoolCode: schoolCode, FamilyCode: familyCode, Login: login,
            isViewLesson: isViewLesson,                                        // NEW
            QnNo: isViewLesson ? (params.get("QnNo") || undefined) : undefined, // NEW
          }),
        });
        if (!metaRes.ok) throw new Error("Network response was not ok for lesson metadata.");

        const meta = await metaRes.json();

        if (!meta || !meta.qns)
          throw new Error("Invalid metadata received from API.");

        const qnNo = params.get("QnNo");

        // NOTE: with the backend now filtering to the requested QnNo(s)
        // itself when isViewLesson is true, meta.qns already comes back
        // as exactly the right set. This client-side filter is left in
        // place as a harmless no-op safety net — it only ever removes
        // items that shouldn't be there, never adds missing ones.
        if (isViewLesson && qnNo) {

          const selected = qnNo.split(",");

          meta.qns = meta.qns.filter(
            (q: any) => selected.includes(q.QnNo)
          );

        }

        setLessonMeta(meta);
        const totalPagesFromMeta = meta.qns.length;
        setTotalPages(totalPagesFromMeta);

        if (isResuming) {
          const originalTotal = meta.noOfQnsExe || meta.totQnsAll;
          const receivedCount = meta.qns.length;

          if (receivedCount < originalTotal) {
            pageToLoad = 1;
          } else {
            pageToLoad = (lastCompletedPage || 0) + 1;
          }

          if (pageToLoad > receivedCount) {
            pageToLoad = 1;
          }
        } else {
          pageToLoad = 1;
        }
        setCurrentPage(pageToLoad);

        const questionsRes = await fetch(`${url}Question/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            folder: folderParam, qns: meta.qns, calledFrom: 'Question', sessionId: isViewLesson ? null : currentSessionId,
            runid: isViewLesson ? null : currentSessionId, SchoolCode: schoolCode, FamilyCode: familyCode, Login: login
          }),
        });
        if (!questionsRes.ok) throw new Error("Failed to fetch question HTML.");
        const questionsData = await questionsRes.json();
        setAllQuestionsHtml(questionsData.Questions);

      } catch (e: any) {
        // console.error(e);
        setError(`Failed to load lesson data: ${e.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchLessonData();
  }, [url, folderParam, showResumePrompt]);

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      return;
    }

    if (isViewLesson) {
      const calledFrom =
        params.get("CalledFrom") ||
        params.get("calledFrom");

      if (calledFrom) {
        const redirectUrl = decodeURIComponent(calledFrom);

        console.log("VIEW LESSON DONE - CalledFrom:", calledFrom);
        console.log("VIEW LESSON DONE - Redirecting to:", redirectUrl);

        window.location.href = redirectUrl;
        return;
      }
    }

    const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
    const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
    const calledFrom = params.get("calledFrom") || "";
    navigate(
      `/STUDENT/Tutorials/Result?DicCode=${encodeURIComponent(dicCode)}&LsnTestCode=${encodeURIComponent(lsnTestCode)}&SessionID=${sessionId}&source=lesson&complete=1` +
      (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : "")
    );
  };


  const renderQuestionComponent = () => {
    if (loading) {
      return <tr><td colSpan={100}><Loading /></td></tr>;
    }

    if (
      !lessonMeta ||
      !lessonMeta.qns[currentPage - 1] ||
      !allQuestionsHtml[lessonMeta.qns[currentPage - 1].QnNo] ||
      (!isViewLesson && !sessionId)
    ) {
      return null;
    }

    const currentQuestion = lessonMeta.qns[currentPage - 1];
    const questionHtml = allQuestionsHtml[currentQuestion.QnNo];
    const isCompleting = currentPage === totalPages;

    const props = {
      lessonMeta,
      questionHtml,
      currentPage,
      totalPages,
      goToNextPage,
      isViewLesson,
      previewMode,

      singleQuestion:
        isViewLesson &&
        totalPages === 1,
      showAlert,
      correctAudio,
      incorrectAudio,
      assetsBaseUrl,
      sessionId: sessionId,
      isCompleting: isCompleting,
      updateSessionPoints: updateSessionPoints,
      hwid: hwid,
      subject: subjectParam || undefined
    };

    let finalQnType = currentQuestion.QnType;


    if (finalQnType === 'O') {
      const detectedType = getQuestionTypeFromHtml(questionHtml, finalQnType);
      if (detectedType && detectedType !== 'O') {
        finalQnType = detectedType;
      }
    }

    switch (finalQnType) {
      case 'O':
        return <OQns {...props} />;
      case 'O_RADIO':
        return <OQns {...props} />;
      case 'O_IMAGE':
        return <ImageQns {...props} />;
      case 'W':
        return <WQns {...props} />;
      case 'F':
        return <FQns {...props} />;
      case 'D':
        return <DQns {...props} />;
      case 'B':
        return <BQns {...props} />;
      case 'N':
        return <NQns {...props} />;
      case 'I':
        return <IQns {...props} />;
      case 'C':
        return <CQns {...props} />;
      case 'M':
        return <MQns {...props} />;
      case 'L':
        return <LQns {...props} />;
      default:
        return <tr><td style={{ color: 'red' }}>Page not found</td></tr>;
    }
  };

  if (error) return <div style={{ padding: 16, color: 'crimson' }}>{error}</div>;

  return (
    <form id="form1">
      <input
        id="hidQuestionData"
        type="hidden"
        value={buildLegacyHiddenQuestionData(lessonMeta?.qns)}
        readOnly
      />
      <table className="QuestionTableT">
        <tbody>
          <tr id="trQntitle">
            <td id="tdQnTitle" className="HeadMsg">
              Lesson = <span id="spanLessonName" style={{ color: 'maroon', fontWeight: 'bold' }}>{lessonMeta?.name || lessonNameParam}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Question <span id="spanCurrentQuestionNo" style={{ color: 'maroon' }}>{currentPage}</span> of{' '}
              <span id="spanTotalNoOfQuestions" style={{ color: 'maroon' }}>{totalPages}</span>
              <WhiteboardLink
                schoolCode={whiteboardSchoolCode}
                familyCode={whiteboardFamilyCode}
                login={whiteboardLogin}
              />
            </td>
          </tr>
          {renderQuestionComponent()}
        </tbody>
      </table>
      <div id="dialog-confirm" title="">
        <p><span className="ui-icon ui-icon-alert" id="spanAlertT"></span></p>
      </div>
    </form>
  );
};

export default Question;
